import { WorkOrderPriceStatusEnum } from 'gql/graphql';

import type { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';

enum AppliesToLinkStatusEnum {
    AdditionalCondition = 'AdditionalCondition',
    ContractCondition = 'ContractCondition',
    Draft = 'Draft',
    NewRecord = 'NewRecord',
    None = 'None',
}

export const AppliesToLinkStatusValue: Record<string, string> = {
    [AppliesToLinkStatusEnum.ContractCondition]: 'Условие договора',
    [AppliesToLinkStatusEnum.AdditionalCondition]: 'Условие ДС',
    [AppliesToLinkStatusEnum.NewRecord]: 'Новая запись',
    [AppliesToLinkStatusEnum.Draft]: 'Черновик',
    [AppliesToLinkStatusEnum.None]: 'Нет',
};

export const AppliesOrderChangeToLinkStatusValue: Record<string, string> = {
    [WorkOrderPriceStatusEnum.ContractCondition]: 'Условие договора',
    [WorkOrderPriceStatusEnum.AdditionalCondition]: 'Условие ДС',
    [WorkOrderPriceStatusEnum.NewRecord]: 'Новая запись',
    [WorkOrderPriceStatusEnum.Draft]: 'Черновик',
    [WorkOrderPriceStatusEnum.None]: 'Нет',
};

export const useRatioUerRowItemsColumns = (isWorkOrderChange?: boolean) => {
    const columns = useMemo<ColDef<any>[]>(
        () => [
            {
                field: 'appliesToCode',
                headerName: 'Шифр',
                width: 200,
            },
            {
                field: 'appliesToCodeName',
                headerName: 'Наименование',
                minWidth: 250,
                flex: 1,
            },
            {
                field: 'appliesToLinkStatus',
                headerName: 'Статус связи',
                valueFormatter: (params) => {
                    const { data } = params;

                    const currentData =
                        isWorkOrderChange && data
                            ? AppliesOrderChangeToLinkStatusValue[data.appliesToLinkStatus]
                            : AppliesToLinkStatusValue[data.appliesToLinkStatus];

                    return currentData || '';
                },
                width: 162,
            },
        ],
        [isWorkOrderChange],
    );

    return useMemo(
        () => ({
            columns,
        }),
        [columns],
    );
};
